import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { OnboardingWelcomeModalViewedEventTracking } from '@/modules/auth/models/segmentevents/OnboardingWelcomeModalViewedEventTracking';

export class OnboardingWelcomeModalQuitEventTracking extends OnboardingWelcomeModalViewedEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ONBOARDING_WELCOME_MODAL_QUIT;
}
